import React from 'react'
import { getLabelAndValue, addObjArrayValues } from '../../../../utils/functionalitiesHelper'
import { ReactComponent as SpentMoneyPrimary } from '../../../../assets/icons/money-sack.svg'
import { ReactComponent as BreedPrimary } from '../../../../assets/icons/paw.svg'
import { ReactComponent as SpentMoneySecondary } from '../../../../assets/icons/money-sack-secondary.svg'
import { ReactComponent as BreedSecondary } from '../../../../assets/icons/paw-secondary.svg'
import { ReactComponent as TrophyPrimary } from '../../../../assets/icons/trophy.svg'

const rankingDecorator = { suffix: { value: 'º' } }
const firstDecorator = { prefix: { label: <TrophyPrimary /> } }
const RANKING_INFO = {
  breed: {
    type: 'Raças',
    icon: {
      ranked: <BreedPrimary />,
      noData: <BreedSecondary />
    }
  },
  customer: {
    type: 'Clientes',
    icon: {
      ranked: <SpentMoneyPrimary />,
      noData: <SpentMoneySecondary />
    }
  }
}

export const getServicesData = (data) => {
  return {
    services: {
      data: data ? getLabelAndValue(data.mostPerformedServices, 'name', 'total', false, 24) : [],
      total: data ? addObjArrayValues(data?.mostPerformedServices, 'total') : 0
    },
    customers: data ? getRankedData(data.mostSpendingUsers) : [],
    breeds: data ? getRankedData(data.mostAttendedBreeds) : []
  }
}

export const getRankedData = (data) => {
  const values = getLabelAndValue(data, 'name', '', true, 15, { ...rankingDecorator })
  const topValue = { ...values[0], decorator: { ...values[0].decorator, ...firstDecorator } }
  return [topValue, ...values.slice(1)]
}

export const RANKING_MIN_AMOUNT = 3

export const TOP_SERVICES = (sameDate, servicesData) => {
  const maxData = Math.max(...servicesData.data.map(item => item.value))
  const topServices = servicesData.data.filter(service => service.value === maxData).map(day => day.label)
  const lastService = topServices[topServices.length - 1]
  const topServicesWithoutLast = topServices.slice(0, -1)
  const topServicesTitle = topServicesWithoutLast?.join(', ') + (topServicesWithoutLast?.length ? ' e ' : '') + lastService
  return ({
    title: <><strong>{topServices?.length > 1 ? 'Serviços mais realizados:' : 'Serviço mais realizado:'}</strong><br/>{topServicesTitle}</>,
    subtitle: `${servicesData.total} ${servicesData.total === 1 ? 'serviço realizado' : 'serviços realizados'} ${sameDate ? 'neste' : 'no'} mês pelo profissional principal e substitutos.`,
    data: servicesData?.data,
    type: 'list',
    barStyle: { height: '16px' },
    maxColor: true,
    breakLine: true,
    labelWidth: 150
  })
}

export const TOP_CUSTOMERS = (sameDate, customersData) => {
  return ({
    title: <>TOP {RANKING_MIN_AMOUNT}: Clientes que mais gastaram com serviços {sameDate ? 'neste' : 'no'}  mês</>,
    data: customersData ?? [],
    type: 'list',
    rankBy: 'order',
    barStyle: { height: '16px' },
    maxColor: true,
    icon: RANKING_INFO.customer.icon.ranked,
    labelWidth: 150
  })
}

export const TOP_BREEDS = (sameDate, breedsData) => {
  return ({
    title: <>TOP {RANKING_MIN_AMOUNT}: Raças mais atendidas {sameDate ? 'neste' : 'no'} mês</>,
    data: breedsData ?? [],
    type: 'list',
    rankBy: 'order',
    barStyle: { height: '16px' },
    maxColor: true,
    icon: RANKING_INFO.breed.icon.ranked,
    labelWidth: 150
  })
}

export const INSUFFICIENT_DATA = (sameDate, rank) => {
  const INSUFFICIENT_DATA_SUBTITLE = {
    true: 'Ainda não temos informações suficientes para montar este pódio. Continue com seus atendimentos do mês.',
    false: 'Não temos informações suficientes para montar o pódio do mês selecionado. Continue com seus atendimentos nos próximos meses.'
  }
  return {
    icon: RANKING_INFO[rank].icon.noData,
    title: `TOP ${RANKING_MIN_AMOUNT} ${RANKING_INFO[rank].type}: ${sameDate ? 'Em andamento' : 'Dados insuficientes'}`,
    subtitle: INSUFFICIENT_DATA_SUBTITLE[sameDate]
  }
}
